import { apiHolder as api, apis, locationHelper, isElectron, } from 'api';
import cloneDeep from 'lodash/cloneDeep';
import { attachmentDownloadAction } from '@web-common/state/action';
import { transMailContactModel2ContactItem } from '@web-common/utils/contact_util';
import { doGetMailContactModelByContactItem } from '@web-common/state/selector/contact';
import { AppActions, ContactActions } from '@web-common/state/reducer';
import { actions as mailTabActions, tabType } from '@web-common/state/reducer/mailTabReducer';
import { actions as mailActions } from '@web-common/state/reducer/mailReducer';
import { config } from 'env_def';
import store from '@web-common/state/createStore';
import SiriusModal from '@web-common/components/UI/Modal/SiriusModal';
import SiriusMessage from '@web-common/components/UI/Message/SiriusMessage';
import { getIn18Text } from 'api';
const mailConfigApi = api.api.requireLogicalApi(apis.mailConfApiImpl);
const contactApi = api.api.requireLogicalApi(apis.contactApiImpl);
const systemApi = api.api.getSystemApi();
const performanceApi = api.api.requireLogicalApi(apis.performanceImpl);
const trackApi = api.api.requireLogicalApi(apis.dataTrackerApiImp);
const delImgHost = (html) => {
    if (!html)
        return '';
    const contextPath = config('contextPath');
    const host = mailConfigApi.getWebMailHost(true);
    if (!host || !isElectron())
        return html;
    return html.replaceAll('src="/js6/s', `src="${host}${contextPath}/js6/s`);
};
const findSameOptTab = (originId, writeType) => {
    if (!originId || !writeType)
        return;
    if (!(writeType.includes('reply') || writeType.includes('forward'))) {
        return false;
    }
    const tabList = store.getState().mailTabReducer.tabList;
    const findTab = tabList.find(item => {
        const { extra } = item;
        if (extra) {
            return extra.originId === originId && extra.writeType === writeType;
        }
        return false;
    });
    return findTab;
};
const findSameMail = (originId, writeType, id) => {
    if (!originId || !writeType)
        return;
    if (!(writeType.includes('reply') || writeType.includes('forward'))) {
        return false;
    }
    const mails = store.getState().mailReducer.mails;
    const findMail = mails.find(item => {
        return item.id === originId && item.writeType === writeType && item.cid === id;
    });
    return findMail;
};
export const handleMail = async (dispatch, realData) => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
    const mailApi = api.api.requireLogicalApi(apis.mailApiImpl);
    const storeApi = api.api.getDataStoreApi();
    const eventApi = api.api.getEventApi();
    performanceApi.time({
        statKey: 'write_mail_load',
        statSubKey: `${realData.cid}`,
    });
    const { eventTarget, tabTempId, entry, originMailId, unableRecoverAttCount } = realData;
    if (locationHelper.testPathMatch('/writeMail') && isElectron()) {
        if (!eventTarget)
            return;
        const curWinMsgs = await window.electronLib.windowManage.getCurWindow();
        if (!curWinMsgs)
            return;
        if ((curWinMsgs === null || curWinMsgs === void 0 ? void 0 : curWinMsgs.webId) !== Number(eventTarget))
            return;
    }
    if (locationHelper.isMainPage() && originMailId && entry.writeLetterProp) {
        const findTab = findSameOptTab(originMailId, entry.writeLetterProp);
        const findMail = findTab ? findSameMail(originMailId, entry.writeLetterProp, findTab.id) : false;
        if (findMail) {
            if (!locationHelper.testHrefMatch('#mailbox')) {
                eventApi.sendSysEvent({
                    eventName: 'routeChange',
                    eventData: {
                        name: 'mailbox',
                    },
                });
            }
            eventApi.sendSysEvent({
                eventName: 'writePageDataExchange',
                eventStrData: 'writeTabCreated',
                eventData: realData,
            });
            return;
        }
    }
    realData.extraOperate = realData.extraOperate || '';
    let content = '';
    const data = cloneDeep(realData);
    const origContent = delImgHost((_b = (_a = data === null || data === void 0 ? void 0 : data.entry) === null || _a === void 0 ? void 0 : _a.content) === null || _b === void 0 ? void 0 : _b.content);
    content += origContent;
    data.entry.content.content = content;
    const showContact = ((_c = storeApi.getSync('showContact')) === null || _c === void 0 ? void 0 : _c.data) !== 'false';
    const ccStatusLocalstore = storeApi.getSync('ccStatus').data;
    const bccStatusLocalstore = storeApi.getSync('bccStatus').data;
    dispatch(AppActions.doWriteMail(Object.assign(Object.assign({}, data), { status: {
            cc: ['open', undefined].includes(ccStatusLocalstore),
            bcc: bccStatusLocalstore === 'open',
            showContact,
            keyword: '',
            init: false,
            conferenceShow: false,
            conferenceSetting: true,
            praiseMailShow: false,
            praiseMailSetting: false,
            taskMailShow: false,
            taskMailSetting: false,
            puretext: false,
        }, focusTitle: false, writeType: (_d = data === null || data === void 0 ? void 0 : data.entry) === null || _d === void 0 ? void 0 : _d.writeLetterProp, resetCont: locationHelper.testPathMatch('/writeMail') && isElectron() ? true : false })));
    if (locationHelper.testPathMatch('/writeMail') && isElectron()) {
        dispatch(AppActions.doSetWriteMailStatus('reset'));
    }
    if (((_e = data === null || data === void 0 ? void 0 : data.entry) === null || _e === void 0 ? void 0 : _e.writeLetterProp) && ['forward', 'forwardAsAttach', 'common'].includes((_f = data === null || data === void 0 ? void 0 : data.entry) === null || _f === void 0 ? void 0 : _f.writeLetterProp)) {
        dispatch(ContactActions.doFocusSelector('focusto'));
    }
    else {
        dispatch(ContactActions.doFocusSelector('focusContent'));
    }
    if (!isElectron() && !locationHelper.isMainPage() && !locationHelper.testPathMatch('/writeMail')) {
        dispatch(AppActions.doShowWebWrite(true));
    }
    const startTime = new Date().getTime();
    let token = '';
    systemApi.doGetCookies(true).then(cookies => {
        token = cookies.QIYE_TOKEN;
    });
    const writeMailTimer = setInterval(() => {
        var _a;
        const mails = store.getState().mailReducer.mails;
        const mail = mails.find(c => c.cid === data.cid);
        if (!mail) {
            clearInterval(writeMailTimer);
            return;
        }
        try {
            const attSize = (_a = mail.entry.attachment) === null || _a === void 0 ? void 0 : _a.filter(file => file.inlined).reduce((prev, next) => prev + (next.fileSize || 0), 0);
            systemApi.doGetCookies(true).then(cookies => {
                trackApi.track('pc_mail_write_time', {
                    mailSize: mail.totalSize,
                    attSize,
                    time: new Date().getTime() - startTime,
                    composeId: mail.cid,
                    reloginOccured: token === cookies.QIYE_TOKEN,
                });
            });
        }
        catch (error) {
            console.log(error);
        }
    }, 15 * 60 * 10000);
    if (unableRecoverAttCount && unableRecoverAttCount > 0) {
        SiriusModal.warning({
            title: getIn18Text('YOUJIANNEIRONGHUIFUCHENGGONG,YUAN') + unableRecoverAttCount + getIn18Text('GEFUJIANXUYAO'),
            content: '',
            okType: 'primary',
            okText: getIn18Text('QUEDING'),
        });
    }
    if (locationHelper.testPathMatch('/')) {
        const mailTabModel = {
            id: data.cid + '' || data.entry.id,
            title: ((_g = data === null || data === void 0 ? void 0 : data.entry) === null || _g === void 0 ? void 0 : _g.title) || getIn18Text('WUZHUTI'),
            type: ((_h = data === null || data === void 0 ? void 0 : data.entry) === null || _h === void 0 ? void 0 : _h.writeLetterProp) || tabType.writeCommon,
            closeable: true,
            isActive: true,
        };
        setTimeout(() => {
            if (tabTempId) {
                dispatch(mailTabActions.doChangeTabById({ id: tabTempId, tabModel: mailTabModel, setCurrent: true }));
            }
            else {
                dispatch(mailTabActions.doSetTab(mailTabModel));
            }
        });
        !locationHelper.testHrefMatch('#mailbox') &&
            eventApi.sendSysEvent({
                eventName: 'routeChange',
                eventData: {
                    name: 'mailbox',
                },
            });
        eventApi.sendSysEvent({
            eventName: 'writePageDataExchange',
            eventStrData: 'writeTabCreated',
            eventData: realData,
        });
    }
    if (['forward', 'forwardAsAttach', 'editDraft', 'edit', 'common', 'reply', 'replyAll', 'replyWithAttach', 'replyAllWithAttach'].includes(((_j = data === null || data === void 0 ? void 0 : data.entry) === null || _j === void 0 ? void 0 : _j.writeLetterProp) || '') &&
        data.entry.attachment &&
        data.entry.attachment.length > 0) {
        if (data.cid) {
            if (((_k = data === null || data === void 0 ? void 0 : data.entry) === null || _k === void 0 ? void 0 : _k.writeLetterProp) === 'forwardAsAttach') {
                mailApi
                    .doSaveTemp({ content: data, saveDraft: true, auto: true, _account: data._account || '' })
                    .then(res => {
                    return res === null || res === void 0 ? void 0 : res.draftId;
                })
                    .then(res => {
                    if (res) {
                        mailApi.doGetMailContent(res, false, true, undefined, { _account: data._account }).then(mail => {
                            var _a, _b, _c;
                            if (mail && mail.entry.attachment && mail.entry.attachment.length > 0) {
                                let value = mail.entry.attachment[0];
                                if ((_a = data === null || data === void 0 ? void 0 : data.entry) === null || _a === void 0 ? void 0 : _a.attachment)
                                    value = Object.assign(Object.assign({}, value), { id: (_b = data === null || data === void 0 ? void 0 : data.entry) === null || _b === void 0 ? void 0 : _b.attachment[0].id, realId: ((_c = data === null || data === void 0 ? void 0 : data.entry) === null || _c === void 0 ? void 0 : _c.attachment[0].realId) || 0 });
                                dispatch(mailActions.doChangeCacheAttachment({ id: data.cid, type: 'forwardAsAttach', value, operationType: 'add' }));
                            }
                        });
                    }
                });
            }
            else {
                data.entry.attachment.forEach(attachment => {
                    if (attachment.inlined) {
                        dispatch(mailActions.doChangeCacheAttachment({
                            id: data.cid,
                            type: 'originalInlineImg',
                            value: attachment,
                            operationType: 'add',
                            originFileUrl: attachment.fileUrl,
                        }));
                    }
                    else if (attachment.cloudAttachment) {
                        dispatch(mailActions.doChangeCacheAttachment({ id: data.cid, type: 'originalCloudFile', value: attachment, operationType: 'add' }));
                    }
                    else {
                        dispatch(mailActions.doChangeCacheAttachment({ id: data.cid, type: 'originalFile', value: attachment, operationType: 'add' }));
                    }
                });
            }
        }
        const filterAttachment = data.entry.attachment.filter(item => !item.inlined);
        filterAttachment.forEach(attachment => {
            const temp = Object.assign(Object.assign({}, attachment), { mailId: data.cid, downloadContentId: data.entry.id, downloadId: attachment.fileUrl + data.entry.id, type: 'download', cloudAttachment: attachment.type === 'netfolder' });
            dispatch(attachmentDownloadAction(temp, {
                forward: true,
                entryId: data.entry.id,
                cid: data.cid || 0,
            }));
        });
    }
    eventApi.sendSysEvent({
        eventName: 'mailAliasAccountListChange',
        eventData: {
            mailId: data.cid,
        },
    });
    mailApi.getDefaultCCBCC().then(async (res) => {
        const { cc, bcc } = res;
        if (cc && cc.length > 0) {
            const ccContact = await contactApi.doGetContactByEmails(cc.map(i => ({ mail: i })), 'cc');
            const target = ccContact.map(transMailContactModel2ContactItem);
            const receiver = await doGetMailContactModelByContactItem(target, 'cc');
            dispatch(mailActions.doModifyReceiver({
                receiver: receiver,
                receiverType: 'cc',
                operation: 'paste',
            }));
        }
        if (bcc && bcc.length > 0) {
            const bccContact = await contactApi.doGetContactByEmails(bcc.map(i => ({ mail: i })), 'bcc');
            const target = bccContact.map(transMailContactModel2ContactItem);
            const receiver = await doGetMailContactModelByContactItem(target, 'bcc');
            dispatch(mailActions.doModifyReceiver({
                receiver: receiver,
                receiverType: 'bcc',
                operation: 'paste',
            }));
        }
    });
};
export default (dispatch) => {
    const eventApi = api.api.getEventApi();
    const eventId = eventApi.registerSysEventObserver('writeLatter', {
        func: async ({ eventData }) => {
            console.log('writeLatterEventData', eventData);
            let realData = eventData === null || eventData === void 0 ? void 0 : eventData.result;
            if (!realData)
                return;
            await handleMail(dispatch, realData);
        },
    });
    eventApi.registerSysEventObserver('preCreateWriteTab', {
        func: async ({ eventData }) => {
            console.log('preCreateWriteTabEventData', eventData);
            if (locationHelper.testPathMatch('/')) {
                const { tabTempId, originId, writeType } = eventData;
                const findTab = findSameOptTab(originId, writeType);
                if (findTab) {
                    dispatch(mailTabActions.doChangeCurrentTab(findTab.id));
                    return;
                }
                const mailTabModel = {
                    id: tabTempId,
                    title: '加载中...',
                    type: tabType.temp,
                    closeable: true,
                    isActive: true,
                    extra: {
                        originId,
                        writeType,
                    },
                };
                dispatch(mailTabActions.doSetTab(mailTabModel));
            }
        },
    });
    eventApi.registerSysEventObserver('destoryWriteTab', {
        func: async ({ eventData }) => {
            console.log('destoryWriteTabdestoryWriteTab', eventData);
            if (locationHelper.testPathMatch('/')) {
                const { originId, writeType } = eventData;
                const findTab = findSameOptTab(originId, writeType);
                if (findTab) {
                    SiriusMessage.error({ content: '创建失败' });
                    dispatch(mailTabActions.doCloseTab(findTab.id));
                    return;
                }
            }
        },
    });
    return eventId;
};
